import { UserProfile } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { useTheme } from './ThemeProvider';
import { useEffect, useState } from 'react';

export function UserPage() {
  const { theme } = useTheme();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkTheme = () => {
      if (theme === 'dark') {
        setIsDark(true);
      } else if (theme === 'light') {
        setIsDark(false);
      } else {
        // System
        const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        setIsDark(systemDark);
      }
    };

    checkTheme();

    // Listen for system theme changes if theme is 'system'
    if (theme === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = (e: MediaQueryListEvent) => setIsDark(e.matches);
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
  }, [theme]);

  return (
    <div className="min-h-screen bg-gray-50 py-8 dark:bg-slate-950 flex justify-center items-start">
      <div className="w-full max-w-7xl px-4 flex justify-center">
        <UserProfile 
          appearance={{
            baseTheme: isDark ? dark : undefined,
            variables: {
              colorShadow: 'transparent',
            },
            elements: {
              rootBox: "w-full mx-auto",
              card: "w-full !shadow-none border border-gray-200 dark:border-slate-700 !max-w-none",
              navbar: "!border-r-gray-200 dark:!border-r-slate-700",
              navbarButton: "text-gray-600 dark:text-gray-300",
              headerTitle: "text-gray-900 dark:text-white",
              headerSubtitle: "text-gray-500 dark:text-gray-400"
            }
          }}
        />
      </div>
    </div>
  );
}

export default UserPage;
